import React from "react";
import { VideoBack, TopBack, TopContainer, TopContent, TopH1, TopP } from "./topStyled";
import Video from '../../videos/video.mp4'

const Top = () => {
    return(
        <TopContainer id="home">
            <TopBack>
            <VideoBack autoPlay loop muted src={Video} type='video/mp4' />
            </TopBack>
            <TopContent>
                <TopH1>Bem vindos ao meu curriculo profissional web</TopH1>
                <TopP> Prazer, sou João Vítor e este curriculo foi feito utilizando JS/React e suas funcionalidades.
                     Irá se manter atualizado de acordo com meu desenvolvimento no mundo da programação. </TopP>
            </TopContent>
        </TopContainer>

    );
};

export default Top;